import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { AlignSelfType } from 'common/types/styleTypes'
import React from 'react'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'
import { FlexAlignment } from '../../ui-lib/alignment/flex-alignment'

export interface AlignSelfControlProps {
  alignSelf: AlignSelfType | undefined
  mobileAlignSelf?: AlignSelfType | undefined
  update: (val: AlignSelfType) => void
  mobileUpdate?: (val: AlignSelfType) => void
  className?: string
}

export const AlignSelfControl = ({
  alignSelf,
  mobileAlignSelf,
  update,
  mobileUpdate,
  className,
}: AlignSelfControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultAlignSelf = getMobileOrDesktop(
    alignSelf,
    mobileAlignSelf,
    isMobile,
  )

  const onChange = (align: AlignSelfType) => {
    return getMobileOrDesktop(update, mobileUpdate, isMobile)(align)
  }

  return (
    <FlexAlignment
      value={resultAlignSelf}
      update={onChange}
      className={className}
    />
  )
}
